<mat-card id="card" fxLayout="column" class="mainContentBody">
  <mat-card-content fxFlex [style.overflow]="'auto'" fxLayout="column" class="mainContentBodyContent">
    <h2>Dettaglio postazione</h2>
    <div fxLayout="column" class="responsive-mat-form">
      <form [formGroup]="form" fxLayout="column">
        <!-- Id field -->
        <mat-form-field>
          <input matInput formControlName="id" placeholder="Postazione Id" readonly="true" />
        </mat-form-field>

        <!-- Descrizione field -->
        <mat-form-field fxlayout="column">
          <input matInput formControlName="descrizione" [disabled]="!isJappTenantAdmin()"
            placeholder="Postazione Description" />
          <mat-error *ngIf="form.get('descrizione').errors?.required">
            Campo obbligatorio
          </mat-error>
        </mat-form-field>

        <!--parametri per l'image map punto1-->
        <div>Coordinate primo punto</div>
        <div fxLayout="row">
          <mat-form-field fxlayout="column" fxlayout="column" fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100" [ngStyle]="{'padding-right': 2 + '%'}"
          [ngStyle.xs]="{'padding-right.px': 0}" [ngStyle.sm]="{'padding-right.px': 0}"
          [ngStyle.md]="{'padding-right.px': 0}">
            <input matInput type="number" formControlName="x1" [disabled]="!isJappTenantAdmin()"
              placeholder="X" />
          </mat-form-field>

          <mat-form-field fxlayout="column" fxlayout="column" fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100" [ngStyle]="{'padding-right': 2 + '%'}"
          [ngStyle.xs]="{'padding-right.px': 0}" [ngStyle.sm]="{'padding-right.px': 0}"
          [ngStyle.md]="{'padding-right.px': 0}">
            <input matInput type="number" formControlName="y1" [disabled]="!isJappTenantAdmin()"
              placeholder="Y" />
          </mat-form-field>
        </div>

        <!--parametri per l'image map punto2-->
        <label>Coordinate secondo punto</label>
        <div fxLayout="row">
          <mat-form-field fxlayout="column" fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100" [ngStyle]="{'padding-right': 2 + '%'}"
          [ngStyle.xs]="{'padding-right.px': 0}" [ngStyle.sm]="{'padding-right.px': 0}"
          [ngStyle.md]="{'padding-right.px': 0}">
            <input matInput type="number" formControlName="x2" [disabled]="!isJappTenantAdmin()"
              placeholder="X" />
          </mat-form-field>

          <mat-form-field fxlayout="column" fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100" [ngStyle]="{'padding-right': 2 + '%'}"
          [ngStyle.xs]="{'padding-right.px': 0}" [ngStyle.sm]="{'padding-right.px': 0}"
          [ngStyle.md]="{'padding-right.px': 0}">
            <input matInput type="number" formControlName="y2" [disabled]="!isJappTenantAdmin()"
              placeholder="Y" />
          </mat-form-field>
        </div>
        <!--  Ufficio field -->
        <mat-form-field>
          <mat-select name="ufficio" [disabled]="!isJappTenantAdmin()" [compareWith]="compareDTO"
            formControlName="ufficio" placeholder="Scegli l'ufficio">
            <mat-option *ngFor="let ufficio of uffici" readonly="true" [value]="ufficio">
              {{ufficio.id}} {{ufficio.descrizione}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="form.get('ufficio').errors?.required">
            Campo obbligatorio
          </mat-error>
        </mat-form-field>


        <!-- Campi di informazione operazione -->
        <mat-expansion-panel class="mat-elevation-z0">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Dettagli operazione
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div fxLayout="row">
            <!-- InsertDate field -->
            <mat-form-field fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100"
              [ngStyle]="{'padding-right': 2 + '%'}" [ngStyle.xs]="{'padding-right.px': 0}"
              [ngStyle.sm]="{'padding-right.px': 0}" [ngStyle.md]="{'padding-right.px': 0}">
              <input matInput formControlName="insertDate" placeholder="Insert Date" readonly="true" />
            </mat-form-field>

            <!-- InsertUser field -->
            <mat-form-field fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100">
              <input matInput formControlName="insertUser" placeholder="Insert User" readonly="true" />
            </mat-form-field>
          </div>
          <div fxLayout="row">
            <!-- UpdateDate field -->
            <mat-form-field fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100"
              [ngStyle]="{'padding-right': 2 + '%'}" [ngStyle.xs]="{'padding-right.px': 0}"
              [ngStyle.sm]="{'padding-right.px': 0}" [ngStyle.md]="{'padding-right.px': 0}">
              <input matInput formControlName="updateDate" placeholder="Update Date" readonly="true" />
            </mat-form-field>

            <!-- UpdateUser field -->
            <mat-form-field fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100">
              <input matInput formControlName="updateUser" placeholder="Update User" readonly="true" />
            </mat-form-field>
          </div>
        </mat-expansion-panel>
      </form>
    </div>
    <mat-card-actions>
      <button mat-raised-button (click)="backConfirm('/postazione')" color="primary">Back</button>
      <button mat-raised-button (click)="postazioneSave()" [disabled]="form.invalid || !form.dirty"
        *ngIf="postazione?.deleteDate==null">Save</button>
      <button mat-raised-button (click)="postazioneDelete()" [disabled]="postazione?.id==null"
        *ngIf="postazione?.deleteDate==null">Delete</button>
    </mat-card-actions>
  </mat-card-content>
</mat-card>